import * as api from '../apiCallerProxy';
import { onboardingApiFactory } from './onboardingApiFactory';

export * from './useOnboardingApi';
export default onboardingApiFactory(api);
